import { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface BorderedBoxProps extends PropsWithChildren {
  css?: SystemStyleObject;
}

export function BorderedBox({ children, css: cssProp }: BorderedBoxProps) {
  return (
    <Box
      css={{
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderRadius: 'large',
        borderColor: 'border',
        px: 'space.300',
        py: 'space.50',
        ...cssProp,
      }}
    >
      {children}
    </Box>
  );
}
